import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CardClient(_ref) {
  var img = _ref.img,
    alt = _ref.alt;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.cardClient,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.imageBackground
    }), /*#__PURE__*/_jsx("img", {
      className: styles.image,
      src: img,
      alt: alt
    })]
  });
}